import React from 'react';
import SvgIcon from "@home/components/SvgIcon";
import classNames from "classnames";
import dataFormat from "@home/utils/dbDataFormat/dataFormat";

import './index.scss';

interface IMetricChangePercentProps
  extends React.HTMLAttributes<HTMLDivElement> {
  value?: number | string | null;
}

// 涨跌指标 百分比带箭头的展示
const MetricChangePercent: React.FC<IMetricChangePercentProps> = (props) => {
  const { value, className, ...rest } = props || {};
  let showText: string;
  if(value === null || value === undefined) {
    showText = '-';
  } else if (value === 0 || value == '0') {
    showText = '0%';
  } else {
    const percent = dataFormat({ value, formatRule: { type: 'percent', decimal: 2 } });
    showText = String(percent)?.replace(/^-/, '');
  }
  const status = ['-', '0%'].includes(String(showText)) ? 'default' : (Number(value) > 0 ? 'up' : 'down');
  return <div className={classNames(`dbl-metric-change dbl-metric-change-${status}`, className)} {...rest}>
    {showText}{ status !== "default" ?
      <SvgIcon type={status === 'up' ? 'green-up-new' : 'red-down-new'} /> 
      : ''}
  </div>;
};

export default MetricChangePercent;